import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  cardElevationStyles: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 1,
  },
});
